/* Lecture audio d'un article Conseils d'experts.
   Utilise la synthèse vocale du navigateur : rien à stocker, rien à payer.
   Se masque tout seul si le navigateur ne sait pas lire. */

(function () {
  'use strict';

  function init(racine) {
    var lecteur = racine.querySelector('[data-cx-audio]');
    var corps = racine.querySelector('[data-cx-corps]');
    if (!lecteur || !corps) return;

    if (!('speechSynthesis' in window) || !('SpeechSynthesisUtterance' in window)) {
      lecteur.hidden = true;
      return;
    }

    var btn = lecteur.querySelector('[data-cx-audio-play]');
    var barre = lecteur.querySelector('[data-cx-audio-barre]');
    var duree = lecteur.querySelector('[data-cx-audio-duree]');
    var vitesseBtn = lecteur.querySelector('[data-cx-audio-vitesse]');

    var vitesses = [1, 1.25, 1.5, 0.75];
    var iVitesse = 0;
    var index = 0;
    var enLecture = false;
    var blocs = [];

    /* On lit les titres et les paragraphes, dans l'ordre du document.
       Les tableaux et les blocs de sources sont volontairement sautés :
       ils se lisent mal à voix haute. */
    corps.querySelectorAll('h2, h3, p, li').forEach(function (el) {
      if (el.closest('.cx-tableau, .cx-sources, .cx-maillage')) return;
      var texte = (el.textContent || '').trim();
      if (texte.length < 2) return;
      blocs.push({ el: el, texte: texte });
    });

    if (!blocs.length) {
      lecteur.hidden = true;
      return;
    }

    /* Estimation de durée : environ 165 mots par minute en français. */
    var mots = blocs.reduce(function (n, b) { return n + b.texte.split(/\s+/).length; }, 0);
    function majDuree() {
      var secondes = Math.round((mots / 165) * 60 / vitesses[iVitesse]);
      var m = Math.floor(secondes / 60);
      var s = secondes % 60;
      if (duree) duree.textContent = m + ':' + (s < 10 ? '0' : '') + s;
    }
    majDuree();

    function voixFr() {
      var voix = window.speechSynthesis.getVoices() || [];
      return voix.filter(function (v) { return /^fr/i.test(v.lang); })[0] || null;
    }

    function surligner(i) {
      blocs.forEach(function (b) { b.el.classList.remove('cx-lu'); });
      if (i >= 0 && i < blocs.length) {
        blocs[i].el.classList.add('cx-lu');
        if (barre) barre.style.width = Math.round(((i + 1) / blocs.length) * 100) + '%';
      }
    }

    var garde = null;

    function etatBouton(lecture) {
      enLecture = lecture;
      if (btn) {
        btn.classList.toggle('is-playing', lecture);
        btn.setAttribute('aria-label', lecture ? 'Arrêter la lecture' : "Écouter l'article");
      }

      /* Chrome coupe la synthèse au bout d'une quinzaine de secondes :
         on la relance discrètement tant que la lecture est en cours. */
      clearInterval(garde);
      if (lecture) {
        garde = setInterval(function () {
          if (!enLecture) { clearInterval(garde); return; }
          window.speechSynthesis.pause();
          window.speechSynthesis.resume();
        }, 10000);
      }
    }

    function lire(i) {
      if (i >= blocs.length) {
        arreter();
        return;
      }
      index = i;
      surligner(i);
      var u = new SpeechSynthesisUtterance(blocs[i].texte);
      u.lang = 'fr-FR';
      u.rate = vitesses[iVitesse];
      var v = voixFr();
      if (v) u.voice = v;
      u.onend = function () { if (enLecture) lire(i + 1); };
      u.onerror = function (e) {
        /* « interrupted » et « canceled » arrivent sur un simple changement de
           vitesse ou un stop volontaire : ce ne sont pas des pannes. */
        if (e && (e.error === 'interrupted' || e.error === 'canceled')) return;
        arreter();
      };
      window.speechSynthesis.speak(u);
    }

    function arreter() {
      window.speechSynthesis.cancel();
      etatBouton(false);
      surligner(-1);
      if (barre) barre.style.width = '0';
      index = 0;
    }

    btn.addEventListener('click', function () {
      if (enLecture) {
        window.speechSynthesis.cancel();
        etatBouton(false);
        return;
      }
      etatBouton(true);
      /* Les voix ne sont pas toujours chargées au premier clic. */
      if (!window.speechSynthesis.getVoices().length) {
        setTimeout(function () { if (enLecture) lire(index); }, 250);
      } else {
        lire(index);
      }
    });

    if (vitesseBtn) {
      vitesseBtn.addEventListener('click', function () {
        iVitesse = (iVitesse + 1) % vitesses.length;
        vitesseBtn.textContent = vitesses[iVitesse] + '×';
        majDuree();
        if (enLecture) {
          window.speechSynthesis.cancel();
          lire(index);
        }
      });
    }

    /* La lecture ne survit pas au changement de page. */
    window.addEventListener('beforeunload', function () { window.speechSynthesis.cancel(); });

    /* Certains navigateurs ne chargent les voix qu'après un événement. */
    if (typeof window.speechSynthesis.onvoiceschanged !== 'undefined') {
      window.speechSynthesis.onvoiceschanged = function () {};
    }
  }

  function progression(racine) {
    var barre = racine.querySelector('[data-cx-progress]');
    var corps = racine.querySelector('[data-cx-corps]');
    if (!barre || !corps) return;
    var calcul = function () {
      var r = corps.getBoundingClientRect();
      var total = r.height - window.innerHeight;
      if (total <= 0) { barre.style.width = '0'; return; }
      var lu = Math.min(Math.max(-r.top, 0), total);
      barre.style.width = Math.round((lu / total) * 100) + '%';
    };
    window.addEventListener('scroll', calcul, { passive: true });
    window.addEventListener('resize', calcul);
    calcul();
  }

  function sommaireActif(racine) {
    var nav = racine.querySelector('[data-cx-sommaire]');
    var corps = racine.querySelector('[data-cx-corps]');
    if (!nav || !corps || !('IntersectionObserver' in window)) return;
    var liens = {};
    nav.querySelectorAll('a[href^="#"]').forEach(function (a) {
      liens[a.getAttribute('href').slice(1)] = a.parentElement;
    });
    var obs = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        var li = liens[e.target.id];
        if (!li) return;
        if (e.isIntersecting) {
          Object.keys(liens).forEach(function (k) { liens[k].classList.remove('is-active'); });
          li.classList.add('is-active');
        }
      });
    }, { rootMargin: '-10% 0px -75% 0px' });
    corps.querySelectorAll('h2[id]').forEach(function (h) { obs.observe(h); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.cx').forEach(function (racine) {
      init(racine);
      progression(racine);
      sommaireActif(racine);
    });
  });
})();
